// @core/api/endpoints/document/get_document_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentStatsResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get document statistics
 * Returns aggregate document statistics across all document types, or filtered by type/product.
 */
export async function GetDocumentStats(
  params?: {
  },
  options?: RequestOptions
): Promise<DocumentStatsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-stats`;
  const requestOptions = options;
  return client.get<DocumentStatsResponse>(requestPath, { ...requestOptions, params });
}
